import { ColDef } from "ag-grid-community";
import React from "react";
import { extractAssortmentNameIfNeeded, getServerSideAggregateValueFormatted, renderGroupCount } from "./render-utils";

interface IProps {
    column: any;
    colDef: ColDef;
    node: any;
    rowIndex: number;
    value: string;
    formatValue: (value: any) => string;
}

const LinkRenderer: React.FC<IProps> = (props) => {
    const { colDef, formatValue, node, value, column } = props;
    // eslint-disable-next-line prefer-const
    const params = colDef.cellRendererParams
        ? typeof colDef.cellRendererParams === "object"
            ? colDef.cellRendererParams
            : typeof colDef.cellRendererParams === "function"
              ? colDef.cellRendererParams(props)
              : {}
        : {};

    let { getLink, target } = params;
    const { isServerSide } = params;
    let formattedValue = "";

    if (node.group && colDef.cellRenderer !== "agGroupCellRenderer") {
        if (node.level === 0) {
            if (node.aggData && colDef.aggFunc) {
                formattedValue = formatValue(value);
            }
        } else {
            formattedValue = formatValue(value);
        }
    } else {
        if (colDef.cellRenderer === "agGroupCellRenderer") {
            ({ getLink, target, valueFormatted: formattedValue } = props as any);
        } else {
            formattedValue = formatValue(value);
        }
    }

    const isAggregateValue = isServerSide && (colDef.aggFunc || column?.isAnyFunctionActive());
    if (isAggregateValue) {
        formattedValue = getServerSideAggregateValueFormatted(props as any, formattedValue);
    } else if (isServerSide) {
        formattedValue = extractAssortmentNameIfNeeded(formattedValue, colDef, node);
    }

    const link = !isAggregateValue && getLink && getLink(node);
    if (!link) {
        return <span>{formattedValue}</span>;
    }

    return (
        <>
            <a href={link} target={target}>
                {formattedValue}
            </a>
            {renderGroupCount(props as any)}
        </>
    );
};

export { LinkRenderer };
